import { ProxyServerType } from '@fd/common/biz/proxyType';
import usePoolById from '@/hooks/queries/usePoolById';
import useProxiesInPool from '@/hooks/queries/useProxiesInPool';
import Flex from '../ui/Flex';
import { LucideCopy } from 'lucide-react';
import useCopy from '@/hooks/useCopy';
import Card from '../ui/Card';
import { TestProxyButton } from '@/blocks/TestSingleProxyStatus';
import CopySingleProxyButton from './CopySingleProxyButton';

type ProxiesListProps = {
  poolId: number;
};

export default function ProxiesList(props: ProxiesListProps) {
  const { poolId } = props;
  const { data: proxies } = useProxiesInPool(poolId);
  const { data: pool } = usePoolById(poolId);
  const protocol = pool && pool.protocol !== '' ? pool.protocol : 'http';

  return (
      <Flex.Col gap="5" className="max-h-[80vh] sm:max-h-none overflow-scroll">
        {proxies?.map((proxy, index) => (
          <ProxyItem
            key={index}
            proxy={proxy}
            protocol={protocol}
            index={index}
          />
        ))}
      </Flex.Col>
  );
}

type ProxyItemProps = {
  proxy: ProxyServerType;
  protocol: 'http' | 'https' | 'socks5';
  index: number;
};

function ProxyItem(props: ProxyItemProps) {
  const { proxy, protocol, index } = props;

  const fieldTitleCls = 'text-sm font-semibold';

  return (
    <Card className="w-full bg-primary-background">
      <Flex.Col gap="4" className="w-full">
        <Flex.Row className="gap-4">
          <Flex.Col gap="1" className="w-full">
            <div className={fieldTitleCls}>Host</div>
            <CopyField text={proxy.host} />
          </Flex.Col>
          <Flex.Col gap="1">
            <Flex.Row className="justify-between">
              <div className={fieldTitleCls}>Port</div>
              <div className="text-sm text-[#A3A4A4]">#{index + 1}</div>
            </Flex.Row>

            <CopyField text={proxy.port} />
          </Flex.Col>
        </Flex.Row>
        <Flex.Col gap="1">
          <div className={fieldTitleCls}>Username</div>

          <CopyField text={proxy.username} />
        </Flex.Col>
        <Flex.Col gap="1">
          <div className={fieldTitleCls}>Password</div>
          <CopyField text={proxy.password} />
        </Flex.Col>
        <Flex.Col gap="3" className="w-full">
          <TestProxyButton proxy={proxy} protocol={protocol} />
          <CopySingleProxyButton proxy={proxy} />
        </Flex.Col>
      </Flex.Col>
    </Card>
  );
}

const CopyField = ({ text }: { text: string | number }) => {
  const { copyToClipboard } = useCopy();
  return (
    <Flex.Row className="h-11 px-3 py-2 rounded-md justify-between items-center text-sm text-secondary bg-secondary-background">
      {text}
      <LucideCopy
        className="inline-block h-4 stroke-secondary"
        onClick={() => copyToClipboard(text.toString())}
      />
    </Flex.Row>
  );
};
